import React, { useEffect, useState } from "react";
import { DateTime } from "luxon";
import Hamburger from "../components/Hamburger";

const API_URL = process.env.REACT_APP_API_URL;

const Reservations = () => {
  const [reservations, setReservations] = useState([]);
  
  useEffect(() => {
    fetch(`${API_URL}/api/reservations`)
      .then(res => res.json())
      .then(data => {
        // Handle both wrapped and non-wrapped responses
        setReservations(data.reservations || data || []);
      })
      .catch(err => {
        console.error('Error fetching reservations:', err);
        setReservations([]);
      });
  }, []);
  
  const sortedReservations = [...reservations].sort((a, b) => {
    if (!a.reservationid) return 1;
    if (!b.reservationid) return -1;
    // Extract numeric part from reservationId (e.g., D001 -> 1)
    const numA = parseInt(a.reservationid.replace(/\D/g, ''), 10);
    const numB = parseInt(b.reservationid.replace(/\D/g, ''), 10);
    return numA - numB;
  });

  // Helper function to format UTC date to Eastern time using luxon
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    // Parse as UTC, convert to America/New_York, format as YYYY-MM-DD HH:mm
    const dt = DateTime.fromISO(dateString, { zone: 'utc' }).setZone('America/New_York');
    return dt.toFormat('yyyy-MM-dd HH:mm'); 
  };

  return (
    <div className="container py-4">
      <nav className="navbar">
        <Hamburger />
      </nav>
      <h2 className="mb-4 pt-3">Reservations List</h2>
      <div className="table-responsive">
        <table className="table table-bordered table-striped">
          <thead className="table-dark">
            <tr>
              <th>Reservation ID</th>
              <th>Name</th>
              <th>Attending?</th>
              <th>Date Added</th>
              <th>Last Updated</th>
            </tr>
          </thead>
          <tbody>
            {sortedReservations.map((r, idx) => (
              <tr key={idx}>
                <td className="fw-bold">{r.reservationid}</td>
                <td>{r.first_name + " " + r.last_name}</td>
                <td>
                  <span className={`badge ${r.attending === true ? "bg-success" : "bg-danger"}`}>
                    {r.attending === true ? "Yes" : "No"}
                  </span>
                </td>
                <td className="text-muted small">{formatDate(r.date_created)}</td>
                <td className="text-muted small">{formatDate(r.last_updated)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {sortedReservations.length === 0 && (
        <div className="text-center mt-4">
          <p className="text-muted">No reservations found.</p>
        </div>
      )}
    </div>
  );
};

export default Reservations;